import { Outlet } from 'react-router'
import { useRole } from '@/hooks/useRole'
import { BrandingProvider } from '@/contexts/BrandingContext'

export function CustomerLayout() {
  const { branding } = useRole()

  return (
    <BrandingProvider branding={branding}>
      <Outlet />
    </BrandingProvider>
  )
}
